import request from '@/libs/request'
import { toast } from '../libs/utils'

// 改变接单状态
export async function setOrderStatus (params) {
  let data = await request.post('/order/appointmentOrderCheckOrderInfo/updateOrderCheckOrderInfoStatus', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '改变接单状态失败！' })
  }
}
// 记录接单人
export async function orderOperation (params) {
  let data = await request.post('/order/orderCheckOperator/save', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '记录接单人失败！' })
  }
}
// 获取新系统联营预约表
export async function getNewSystemList (params, loadingFlag = true) {
  let data = await request.post('/order/crmOrderCheckOrderInfo/queryAppointmentList', params, loadingFlag)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询新系统联营预约表列表异常' })
    return false
  }
}

// 获取RIS监控列表
export async function getMonitorData (params) {
  let data = await request.postJson('/tsc/monitor/service', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } 
  throw Error(data.message || '请求监控服务异常')
}

// 监控上传照片
export async function uploadAbnormalImg (params) {
  let data = await request.postFile('/tsc/monitor/MultipartFileUpload', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } 
  throw Error(data.message || '上传图片异常')
}